import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


interface FooterProps {
  onOpenContact?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onOpenContact }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [footerSeason, setFooterSeason] = useState<string>("spring");
  const footerSeasonTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Rotate footer seasons every 6 seconds
    const rotateFooterSeasons = () => {
      setFooterSeason((prevSeason) => {
        const seasons = ["spring", "summer", "fall", "winter"];
        const currentIndex = seasons.indexOf(prevSeason);
        const nextIndex = (currentIndex + 1) % seasons.length;
        return seasons[nextIndex];
      });
    };

    footerSeasonTimer.current = setInterval(rotateFooterSeasons, 6000);

    // Generate random trees for the footer
    const generateFooterTrees = () => {
      const footerTrees = document.getElementById("footerTrees");
      if (!footerTrees) return;

      const containerWidth = footerTrees.offsetWidth;
      const numTrees = Math.floor(containerWidth / 60); // One tree every 60px

      footerTrees.innerHTML = "";

      for (let i = 0; i < numTrees; i++) {
        const tree = document.createElement("div");
        tree.className = "footer-tree";
        tree.style.left = `${Math.random() * containerWidth}px`;
        tree.style.animationDelay = `${Math.random() * 2}s`;
        tree.style.animationDuration = `${3 + Math.random() * 2}s`;
        footerTrees.appendChild(tree);
      }
    };

    generateFooterTrees();
    window.addEventListener("resize", generateFooterTrees);

    return () => {
      if (footerSeasonTimer.current) {
        clearInterval(footerSeasonTimer.current);
      }
      window.removeEventListener("resize", generateFooterTrees);
    };
  }, []);

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onOpenContact) {
      onOpenContact();
    } else {
      navigate("/contact");
    }
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/privacy");
  };

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/terms");
  };

  return (
    <section
      className="footer-wrapper"
      id="winter-section"
      aria-label={t("seasonal.sections.winter", { defaultValue: "Winter Season: Generate Quotes Instantly" })}
    >
      <footer className="footer">
        <div className="container">
          <div className={`footer-scene ${footerSeason}`} id="footerScene">
            <div className="footer-ground"></div>
            {/* Trees will be generated dynamically with JavaScript */}
            <div id="footerTrees"></div>
            {/* Flowers */}
            <div className="footer-flower"></div>
            <div className="footer-flower"></div>
            <div className="footer-flower"></div>
            <div className="footer-flower"></div>
            <div className="footer-flower"></div>
            <div className="footer-flower"></div>
          </div>
          <div className="footer-content">
            <p>{t("footer.copyright")}</p>
            <button onClick={handleContactClick} className="footer-link">
              {t("footer.contactUs")}
            </button>
            <button onClick={handlePrivacyClick} className="footer-link">
              {t("footer.privacyPolicy")}
            </button>
            <button onClick={handleTermsClick} className="footer-link">
              {t("footer.termsOfService")}
            </button>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
